import SimpleTextPage from "../components/SimpleTextPage";

function Credits() {
  return (
    <div style={{ marginInline: "5%", paddingTop: "270px", minHeight: "80vh" }}>
      <SimpleTextPage pageId="25853490-820a-4d08-87b9-16b9bae567d3" />
    </div>
  );
}

export default Credits;
